var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"web@8.2.0"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

/* eslint-disable no-console */
import * as Sentry from '@sentry/nextjs';
import { CaptureConsole } from '@sentry/integrations';
import chalk from 'chalk';
import { publicRuntimeConfig } from './src/utils/publicRuntimeConfig';

Sentry.init({
  dsn: publicRuntimeConfig.sentry.dsn,
  tracesSampleRate: false,
  integrations: [
    new CaptureConsole({
      levels: ['error'],
    }),
  ],
  beforeSend: (event) => {
    const errorMessage = event?.exception?.values[0]?.value;

    if (process.env.NODE_ENV === 'development') {
      console.info(`${chalk.red('Sentry')} - ${errorMessage}`);
      console.info({ event });
      return null;
    }

    const brazeErrorRegex = /Braze Error: Failed to load.*appboycdn\.com\/web-sdk/;
    if (brazeErrorRegex.test(errorMessage)) {
      return null;
    }

    return event;
  },
});

console.info(`Sentry initialized with environment: ${publicRuntimeConfig.sentry.environment}`);
